  eq_r($('.eq-r'));

  // Equal Height rows
function eq_r(items){
  function _eq(){
    $.each(items, function(){
      $(this).height('');
    });
    setTimeout(function(){
      var offsetTop,rows = [];
      $.each(items, function(){
        offsetTop = $(this).offset().top;
        if(!rows[offsetTop])
          rows[offsetTop] = [];
        rows[offsetTop].push($(this));
      });
      for(var key in rows){
        var maxHeight = 0;
        for(var _item in rows[key]){
          if($(rows[key][_item]).height() > maxHeight) maxHeight = $(rows[key][_item]).height();
        }
        for(var _item in rows[key]){
          $(rows[key][_item]).height(maxHeight);
        }
      }
    },200);
  }
  _eq();
  $(window).resize(function () {
    gc_resize(_eq() , 200, "eq-" + Math.floor(Math.random() * Math.floor(1000)));
  });
}

var gc_resize = (function () {
  var timers = {};
  return function (callback, ms, uniqueId) {
    if (!uniqueId) {
      uniqueId = "Don't call this twice without a uniqueId";
    }
    if (timers[uniqueId]) {
      clearTimeout (timers[uniqueId]);
    }
    timers[uniqueId] = setTimeout(callback, ms);
  };
})();
